/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyMobileDevice
 */
export interface WriteOnlyMobileDevice {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileDevice
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileDevice
     */
    deviceId: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMobileDevice
     */
    client?: number;
}

export function WriteOnlyMobileDeviceFromJSON(json: any): WriteOnlyMobileDevice {
    return WriteOnlyMobileDeviceFromJSONTyped(json, false);
}

export function WriteOnlyMobileDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyMobileDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deviceId': json['device_id'],
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function WriteOnlyMobileDeviceToJSON(value?: WriteOnlyMobileDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'device_id': value.deviceId,
        'client': value.client,
    };
}


